module.exports = __webpack_public_path__ + "media/src/images/user-a6663f476ccb085bd07554a17ab69075.png";